<template>
  <div class="customer-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "customerBase",
};
</script>
